"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  * {\n    font-weight: ", "!important;\n  }\n\n  > *:not(:last-child) {\n    margin-right: 16px;\n    flex-shrink: 1;\n  }\n\n  > *:last-child {\n    white-space: nowrap;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  * {\n    font-weight: ", "!important;\n  }\n\n  > *:not(:last-child) {\n    margin-right: 16px;\n    flex-shrink: 1;\n  }\n\n  > *:last-child {\n    white-space: nowrap;\n  }\n"])), function (_a) {
    var $isBold = _a.$isBold;
    return ($isBold ? 'bold' : 'normal');
});
var templateObject_1;
